var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPause = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.75 4a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0zm6 0a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPause);
export default ForwardRef;